package com.ervasstudio.tracoemovimento.pages

import androidx.compose.runtime.*
import com.ervasstudio.tracoemovimento.pages.home.InicioPage
import com.ervasstudio.tracoemovimento.repository.BlogRepository.registerVisit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Text
import com.varabyte.kobweb.worker.rememberWorker
import com.ervasstudio.tracoemovimento.worker.EchoInput
import com.ervasstudio.tracoemovimento.worker.EchoWorker
import com.varabyte.kobweb.core.layout.Layout

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun HomePage() {
    val worker = rememberWorker { EchoWorker { output -> console.log("Echoed: ${output.message}") } }
    LaunchedEffect(Unit) {
        worker.postInput(EchoInput("Hello, worker!"))
            registerVisit()
    }

    InicioPage()
}
